import AdminCategoryPageEditor from "@/components/admin/AdminCategoryPageEditor";
export default function AdminManasikUmrah() {
  return <AdminCategoryPageEditor pageKey="manasik-umrah" pageTitle="Halaman: Manasik Umrah" previewPath="/kategori/manasik-umrah" />;
}
